<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">Sugoku rare: NFTs in Japan</h1>
                <h2 class="subheading">Problems look mighty small from 150 miles up</h2>
                <span class="meta"> Posted in March 2021 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/rare.png" alt="">
                </figure>

                <p>An undercurrent of interest in non-fungible tokens in Japan remains below the waterline but is rapidly gathering force. Part of the reason that we haven’t yet climbed the hype wave here, in my wild guess, is due to the suppression of street art in Japan. Don’t get me wrong. Talented street artists are abundant here – I’ve met several of them – but they remain underground. Graffiti tagging on a public building risks a draconian penalty of five years in prison in Japan.</p>

                <p>So the reflexes to migrate from physical street art to the digital world remain nascent here, but they’re developing, thanks in part to our pioneering friends over at crypto exchange <a href="https://coincheck.com/ja/article/454">Coincheck</a>. We are preparing to back one such a project, currently in stealth, and welcome creatives, developers, and dissenters who would like to join the movement. If you’re passionate about this space, feel free to contact me so I can introduce you to the project’s founder.</p>

                <figure>
                  <img src="" alt="">
                </figure>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px !important;
}
</style>
